import type { FramingComponentEntityTable, FramingComponentId } from "building-types/framing/framingComponentTypes";
import { IJoistProfileType, IJoistProfileTypeToName } from "building-types/framing/iJoistTypes";
import { framingComponentWithIJoistProfile } from "./framingComponents";

function defaultIJoistComponentId(profileType: IJoistProfileType): FramingComponentId {
  switch (profileType) {
    case IJoistProfileType.IJ_9_5_2X3:
      return "defaultIJ_9_5_2x3";
    case IJoistProfileType.IJ_11_875_2X3:
      return "defaultIJ_11_875_2x3";
    case IJoistProfileType.IJ_11_875_2X4:
      return "defaultIJ_11_875_2x4";
    case IJoistProfileType.IJ_14_2X3:
      return "defaultIJ_14_2x3";
    case IJoistProfileType.IJ_14_2X4:
      return "defaultIJ_14_2x4";
    case IJoistProfileType.IJ_16_2X3:
      return "defaultIJ_16_2x3";
    case IJoistProfileType.IJ_16_2X4:
      return "defaultIJ_16_2x4";
    case IJoistProfileType.IJ_18_2X4:
      return "defaultIJ_18_2x4";
    case IJoistProfileType.IJ_20_2X4:
      return "defaultIJ_20_2x4";
  }
}

// IDs use UPPER_CASE because the embedded depth values (e.g. 9_5 → 9.5",
// 11_875 → 11.875") force underscores into the name, which is incompatible
// with the camelCase variable-name convention.
export const DEFAULT_IJ_9_5_2X3_ID = defaultIJoistComponentId(IJoistProfileType.IJ_9_5_2X3);
export const DEFAULT_IJ_11_875_2X3_ID = defaultIJoistComponentId(IJoistProfileType.IJ_11_875_2X3);
export const DEFAULT_IJ_11_875_2X4_ID = defaultIJoistComponentId(IJoistProfileType.IJ_11_875_2X4);
export const DEFAULT_IJ_14_2X3_ID = defaultIJoistComponentId(IJoistProfileType.IJ_14_2X3);
export const DEFAULT_IJ_14_2X4_ID = defaultIJoistComponentId(IJoistProfileType.IJ_14_2X4);
export const DEFAULT_IJ_16_2X3_ID = defaultIJoistComponentId(IJoistProfileType.IJ_16_2X3);
export const DEFAULT_IJ_16_2X4_ID = defaultIJoistComponentId(IJoistProfileType.IJ_16_2X4);
export const DEFAULT_IJ_18_2X4_ID = defaultIJoistComponentId(IJoistProfileType.IJ_18_2X4);
export const DEFAULT_IJ_20_2X4_ID = defaultIJoistComponentId(IJoistProfileType.IJ_20_2X4);

const defaultIJoistComponents = {
  [DEFAULT_IJ_9_5_2X3_ID]: framingComponentWithIJoistProfile(
    IJoistProfileTypeToName[IJoistProfileType.IJ_9_5_2X3],
    IJoistProfileType.IJ_9_5_2X3,
    DEFAULT_IJ_9_5_2X3_ID,
  ),
  [DEFAULT_IJ_11_875_2X3_ID]: framingComponentWithIJoistProfile(
    IJoistProfileTypeToName[IJoistProfileType.IJ_11_875_2X3],
    IJoistProfileType.IJ_11_875_2X3,
    DEFAULT_IJ_11_875_2X3_ID,
  ),
  [DEFAULT_IJ_11_875_2X4_ID]: framingComponentWithIJoistProfile(
    IJoistProfileTypeToName[IJoistProfileType.IJ_11_875_2X4],
    IJoistProfileType.IJ_11_875_2X4,
    DEFAULT_IJ_11_875_2X4_ID,
  ),
  [DEFAULT_IJ_14_2X3_ID]: framingComponentWithIJoistProfile(
    IJoistProfileTypeToName[IJoistProfileType.IJ_14_2X3],
    IJoistProfileType.IJ_14_2X3,
    DEFAULT_IJ_14_2X3_ID,
  ),
  [DEFAULT_IJ_14_2X4_ID]: framingComponentWithIJoistProfile(
    IJoistProfileTypeToName[IJoistProfileType.IJ_14_2X4],
    IJoistProfileType.IJ_14_2X4,
    DEFAULT_IJ_14_2X4_ID,
  ),
  [DEFAULT_IJ_16_2X3_ID]: framingComponentWithIJoistProfile(
    IJoistProfileTypeToName[IJoistProfileType.IJ_16_2X3],
    IJoistProfileType.IJ_16_2X3,
    DEFAULT_IJ_16_2X3_ID,
  ),
  [DEFAULT_IJ_16_2X4_ID]: framingComponentWithIJoistProfile(
    IJoistProfileTypeToName[IJoistProfileType.IJ_16_2X4],
    IJoistProfileType.IJ_16_2X4,
    DEFAULT_IJ_16_2X4_ID,
  ),
  [DEFAULT_IJ_18_2X4_ID]: framingComponentWithIJoistProfile(
    IJoistProfileTypeToName[IJoistProfileType.IJ_18_2X4],
    IJoistProfileType.IJ_18_2X4,
    DEFAULT_IJ_18_2X4_ID,
  ),
  [DEFAULT_IJ_20_2X4_ID]: framingComponentWithIJoistProfile(
    IJoistProfileTypeToName[IJoistProfileType.IJ_20_2X4],
    IJoistProfileType.IJ_20_2X4,
    DEFAULT_IJ_20_2X4_ID,
  ),
};

export const builtInIJoistComponents: FramingComponentEntityTable = defaultIJoistComponents;

export const iJoistComponentsGroupId = "iJoistComponentsGroup";

export function isBuiltInIJoistComponent(id: FramingComponentId): boolean {
  return Object.keys(defaultIJoistComponents).includes(id);
}
